/*! @pentacode/ui v0.1.0 */
import { formatDay as e } from "./charts/format.js";
import { C as t, b as n, d as r, f as i, g as a, h as o, l as s, m as c, p as l, u, v as d, x as f } from "./guide-layout-CrWsmVuf.js";
import { a as p, c as m, d as h, i as g, l as _, o as v, r as y, s as b, u as x } from "./shared-D0HMDGlg.js";
import { i as S, n as C, r as w, t as T } from "./rule-D2ufK5oT.js";
import { r as E } from "./scene-Bdst6a-n.js";
import { t as D } from "./mark-with-scale-values-BK-kseMB.js";
import { n as O, t as k } from "./mark-decorative-DmSkufit.js";
import { t as A } from "./stack-B6GnFAsl.js";
import { i as j, r as M, t as N } from "./theme-BfnA-mmC.js";
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/area.js
function P(e, t = {}) {
	let o = Array.isArray(e) ? e : Array.from(e), u = t.xScale ?? "x", p = t.yScale ?? "y";
	return r(({ markIndex: e }) => {
		let r = t.id ?? `area-y-${e}`, m = s(o, t.x, (e, { index: t }) => t), h = t.y ?? t.y2, g = typeof h == "number" ? o.map(() => h) : s(o, h, (e) => typeof e == "number" ? e : void 0), _ = s(o, t.z, () => null), v = t.color === void 0 ? _ : s(o, t.color, () => null), y = t.z === void 0 && t.color !== void 0 ? v : _, b = t.y1 !== void 0 || t.y2 !== void 0;
		if (b && t.layout) throw TypeError("An area with explicit y1 or y2 endpoints cannot also configure a stack layout");
		let x = b ? void 0 : S(m, g, y, t.layout), C = b ? typeof t.y1 == "number" ? o.map(() => t.y1) : s(o, t.y1, () => 0) : x.starts, w = b ? typeof t.y2 == "number" ? o.map(() => t.y2) : s(o, t.y2 ?? t.y, () => void 0) : x.ends, T = i(o, t.key, {
			groups: y,
			candidates: [m],
			markId: r,
			warningIdentity: t
		}), E = /* @__PURE__ */ new Map();
		return y.forEach((e, t) => {
			let n = f(e ?? null), r = E.get(n);
			r ? r.push(t) : E.set(n, [t]);
		}), {
			id: r,
			states: a(o, t.states),
			seriesFromColor: t.z === void 0 && t.color !== void 0,
			channels: {
				x: {
					scale: u,
					values: m.filter(l)
				},
				y: {
					scale: p,
					values: [...w.filter(c), ...C.filter(c)],
					includeZero: t.y1 === void 0
				},
				color: {
					scale: "color",
					values: v.filter(n)
				}
			},
			render: ({ scales: e, color: n }) => {
				let i = [];
				for (let [a, s] of E) {
					let h = s[0];
					if (h === void 0) continue;
					let _ = y[h] ?? null, b = o[h], x = n(v[h] ?? null), S = d(t.fill, b, h, o, x), E = t.stroke === void 0 ? void 0 : d(t.stroke, b, h, o, x), D = [], O = [], k = [], A = 0, j = () => {
						if (!D.length) return;
						let e = [...O].reverse(), n = t.curve?.area(D, O);
						i.push({
							kind: "area",
							key: `${r}:${a}:segment:${A}`,
							points: [...D, ...e],
							path: n,
							interaction: {
								points: k,
								affinity: "x"
							},
							style: {
								fill: S,
								fillOpacity: t.fillOpacity ?? .2,
								stroke: E,
								strokeWidth: t.strokeWidth
							}
						}), D = [], O = [], k = [], A += 1;
					};
					for (let t of s) {
						let n = m[t], i = g[t], s = C[t], d = w[t];
						if (!l(n) || !c(i) || !c(s) || !c(d)) {
							j();
							continue;
						}
						let h = e[u].map(n), v = e[p].map(d);
						D.push([h, v]), O.push([h, e[p].map(s)]);
						let y = {
							key: `${r}:${a}:${f(T[t])}`,
							markId: r,
							group: _,
							groupLabel: _ == null ? r : String(_),
							datum: o[t],
							datumIndex: t,
							xValue: n,
							yValue: i,
							y1Value: s,
							y2Value: d,
							yInterval: "difference",
							x: h,
							y: v,
							color: S
						};
						k.push(y);
					}
					j();
				}
				return { nodes: [{
					kind: "group",
					key: r,
					className: "ts-chart__area",
					ariaHidden: !0,
					children: i
				}] };
			}
		};
	}, t.motion, t.renderer);
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/dot-layout.js
var F = /* @__PURE__ */ Symbol("resolveDotLayout");
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/resolved-layout-position.js
function I(e, t, n) {
	return R(e, t, n, "xValue", "x");
}
function L(e, t, n) {
	return R(e, t, n, "yValue", "y");
}
function R(e, t, n, r, i) {
	return e.flatMap((e) => {
		let a = t[e.sourceIndex];
		if (!l(a)) return [];
		let o = n.map(a);
		return Number.isFinite(o) ? [{
			...e,
			[r]: a,
			[i]: o
		}] : [];
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/dot.js
function z(e, r = {}) {
	let c = Array.isArray(e) ? e : Array.from(e), d = r.xScale ?? "x", p = r.yScale ?? "y";
	return D(({ markIndex: e }) => {
		let m = r.id ?? `dot-${e}`, h = r.layout;
		if (h?.axis === "x" && r.x !== void 0) throw TypeError("dot: x is derived by its layout and cannot be configured");
		if (h?.axis === "y" && r.y !== void 0) throw TypeError("dot: y is derived by its layout and cannot be configured");
		let g = h?.axis === "x" ? c.map(() => h.anchor) : s(c, r.x, (e, { index: t }) => t), _ = h?.axis === "y" ? c.map(() => h.anchor) : s(c, r.y, (e) => typeof e == "number" ? e : void 0), v = s(c, r.z, () => null), y = r.color === void 0 ? v : s(c, r.color, () => null), b = i(c, r.key, {
			groups: v,
			candidates: h?.axis === "x" ? [_] : h?.axis === "y" ? [g] : [
				g,
				_,
				u(g, _)
			],
			markId: m,
			warningIdentity: r
		}), x = typeof r.r == "number" ? c.map(() => r.r) : s(c, r.r, () => 3.5), S = t(r.rScale, x), C = S ? x.map((e) => o(e) ? S(e) : NaN) : x, w = c.map((e, t) => ({
			datum: e,
			sourceIndex: t
		})), T = (e, t) => {
			let n = [];
			return e.forEach((e) => {
				let { datum: i, sourceIndex: a, xValue: s, yValue: c, x: l, y: u } = e, d = C[a];
				if (!o(d)) return;
				let p = v[a] ?? null, g = f(p), _ = r.fill ?? t(y[a] ?? null), x = `${m}:${g}:${f(b[a])}`, S = {
					key: x,
					markId: m,
					group: p,
					groupLabel: p == null ? m : String(p),
					datum: i,
					datumIndex: a,
					xValue: s,
					yValue: c,
					x: l,
					y: u,
					color: _
				};
				n.push({
					kind: "dot",
					key: x,
					x: l,
					y: u,
					radius: d,
					interaction: {
						point: S,
						affinity: h?.axis === "y" ? "x" : h?.axis === "x" ? "y" : void 0
					},
					style: {
						fill: _,
						fillOpacity: r.fillOpacity,
						stroke: r.stroke,
						strokeOpacity: r.strokeOpacity,
						strokeWidth: r.strokeWidth
					}
				});
			}), { nodes: [{
				kind: "group",
				key: m,
				className: "ts-chart__dot",
				ariaHidden: !0,
				children: n
			}] };
		}, E = {
			...h?.axis === "x" ? {} : { x: {
				scale: d,
				values: g.filter(l)
			} },
			...h?.axis === "y" ? {} : { y: {
				scale: p,
				values: _.filter(l)
			} },
			color: {
				scale: "color",
				values: y.filter(n)
			}
		}, D = {
			id: m,
			seriesFromColor: r.z !== void 0 && r.color === void 0,
			states: a(c, r.states),
			channels: E
		};
		return h ? {
			...D,
			resolveLayout: ({ chart: e, scales: t }) => {
				if (h.axis === "y") {
					let n = I(w, g, B(t[d], d)).filter((e) => o(C[e.sourceIndex])), r = V(h, e, n.map((e) => e.x), n.map((e) => C[e.sourceIndex])), i = n.map((e, t) => ({
						...e,
						yValue: h.anchor,
						y: r[t]
					}));
					return { render: ({ color: e }) => T(i, e) };
				}
				let n = L(w, _, B(t[p], p)).filter((e) => o(C[e.sourceIndex])), r = V(h, e, n.map((e) => e.y), n.map((e) => C[e.sourceIndex])), i = n.map((e, t) => ({
					...e,
					xValue: h.anchor,
					x: r[t]
				}));
				return { render: ({ color: e }) => T(i, e) };
			}
		} : {
			...D,
			render: ({ scales: e, color: t }) => {
				let n = B(e[d], d), r = B(e[p], p), i = L(I(w, g, n), _, r);
				return T(i, t);
			}
		};
	}, r.motion, r.renderer);
}
function B(e, t) {
	if (!e) throw TypeError(`dot: missing ${t} scale`);
	return e;
}
function V(e, t, n, r) {
	let i = e[F]({
		chart: t,
		measuredPositions: n,
		radii: r
	});
	if (i.length !== n.length || i.some((e) => !Number.isFinite(e))) throw TypeError("dot: layout must resolve one finite position per row");
	return i;
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/focus-mark.js
function H(e, t = {}) {
	return {
		...e,
		initialize(n) {
			return {
				...e.initialize(n),
				focus: t
			};
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/text.js
function U(e, t = {}) {
	let o = Array.isArray(e) ? e : Array.from(e), c = t.xScale ?? "x", p = t.yScale ?? "y";
	return r(({ markIndex: e }) => {
		let r = t.id ?? `text-${e}`, m = s(o, t.x, (e, { index: t }) => t), h = s(o, t.y, (e) => typeof e == "number" ? e : void 0), g = s(o, t.text, (e) => e == null ? "" : String(e)), _ = s(o, t.z, () => null), v = t.color === void 0 ? _ : s(o, t.color, () => null), y = i(o, t.key, {
			groups: _,
			candidates: [
				m,
				h,
				u(m, h)
			],
			markId: r,
			warningIdentity: t
		}), b = o.map((e, n) => d(t.anchor, e, n, o, "middle")), x = o.map((e, n) => d(t.dx, e, n, o, 0)), S = o.map((e, n) => d(t.dy, e, n, o, 0)), C = t.rotate === void 0 ? void 0 : o.map((e, n) => d(t.rotate, e, n, o, 0)), w = (e, n) => {
			let i = m[n], a = h[n], o = g[n];
			if (!l(i) || !l(a) || o == null) return;
			let s = _[n] ?? null, u = v[n] ?? null;
			return {
				node: {
					kind: "label",
					key: `${r}:${f(s)}:${f(y[n])}`,
					x: e.scales[c].map(i) + (x[n] ?? 0),
					y: e.scales[p].map(a) + (S[n] ?? 0),
					text: String(o),
					anchor: b[n],
					baseline: "middle",
					rotate: C?.[n],
					fontSize: t.fontSize,
					fontWeight: t.fontWeight
				},
				xValue: i,
				yValue: a,
				group: s,
				colorValue: u
			};
		};
		return {
			id: r,
			states: a(o, t.states),
			channels: {
				x: {
					scale: c,
					values: m.filter(l)
				},
				y: {
					scale: p,
					values: h.filter(l)
				},
				color: {
					scale: "color",
					values: v.filter(n)
				}
			},
			layoutLabels: (e) => o.flatMap((t, n) => {
				let r = w(e, n);
				return r ? [r.node] : [];
			}),
			render: (e) => {
				let { theme: n, color: i } = e, a = [], s = [];
				return o.forEach((c, l) => {
					let u = w(e, l);
					if (!u) return;
					let { node: f, xValue: p, yValue: m, group: h, colorValue: g } = u, _ = d(t.fill, c, l, o, g == null ? n.foreground : i(g));
					a.push({
						...f,
						style: { fill: _ }
					}), s.push({
						key: f.key,
						markId: r,
						group: h,
						groupLabel: h == null ? r : String(h),
						datum: c,
						datumIndex: l,
						xValue: p,
						yValue: m,
						x: f.x,
						y: f.y,
						color: _
					});
				}), {
					nodes: [{
						kind: "group",
						key: r,
						className: "ts-chart__text",
						ariaHidden: !0,
						children: a
					}],
					points: s
				};
			}
		};
	}, t.motion, t.renderer);
}
//#endregion
//#region src/charts/presets/line.ts
function W(t, n, r) {
	let i = r ?? (v(t) ? e : b);
	return j({ items: [{
		id: "x",
		label: "",
		text: (e) => i(e.xValue)
	}, {
		channel: "y",
		label: "",
		text: (e) => n(e.yValue)
	}] });
}
var G = "area-threshold", K = .3;
function q({ value: e, below: t, above: n }, r) {
	let i = r.map((e) => e.value), a = Math.min(0, ...i), o = Math.max(0, ...i), s = o > a ? (e - a) / (o - a) : 1;
	return {
		id: G,
		stops: [
			{
				offset: 0,
				color: t,
				opacity: K
			},
			{
				offset: s,
				color: t,
				opacity: K
			},
			{
				offset: s,
				color: n,
				opacity: K
			},
			{
				offset: 1,
				color: n,
				opacity: K
			}
		]
	};
}
var J = {
	top: 4,
	right: 3,
	bottom: 4,
	left: 3
}, Y = 18, X = 18;
function Z(e, t) {
	let n = e.filter((e) => !t.includes(e.series)), r = e.filter((e) => t.includes(e.series));
	return [...n.length ? [w(n, {
		...m,
		strokeWidth: 2,
		curve: x
	})] : [], ...r.length ? [w(r, {
		...m,
		strokeWidth: 2,
		strokeDasharray: "5 4",
		curve: x
	})] : []];
}
function Q(e, t) {
	let n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), i = [...e].sort((e, n) => t.indexOf(e.series) - t.indexOf(n.series));
	for (let e of i) {
		let t = e.x instanceof Date ? e.x.getTime() : e.x, i = r.get(t) ?? {
			above: 0,
			below: 0
		};
		e.value < 0 ? i.below += e.value : i.above += e.value, r.set(t, i), n.set(e, e.value < 0 ? i.below : i.above);
	}
	return (e) => n.get(e);
}
function ee(e, t) {
	let n = {
		...m,
		y: t
	};
	return [H(z(e, {
		...n,
		r: 6.25
	}), { match: "group" }), H(z(e, {
		...n,
		r: 3.75,
		fill: "var(--ts-chart-focus-fill, Canvas)"
	}), { match: "group" })];
}
function te(e, t) {
	let n = /* @__PURE__ */ new Map();
	for (let t of e) {
		let e = t.x instanceof Date ? t.x.getTime() : t.x, r = n.get(e);
		(!r || t.value > r.value) && n.set(e, t);
	}
	let r = new Set(n.values()), i = e.filter((e) => {
		let i = n.get(e.x instanceof Date ? e.x.getTime() : e.x);
		return r.has(e) || t(e.value) !== t(i.value);
	});
	return k(U(i, {
		...m,
		text: (e) => t(e.value),
		dy: (e) => r.has(e) ? -8 : 14,
		fontSize: 11
	}));
}
function $(e) {
	let t = [...new Set(e.map((e) => e.x instanceof Date ? e.x.getTime() : e.x))], n = t.every((e) => typeof e == "number"), r = n ? Math.min(...t) : 0, i = n ? Math.max(...t) : t.length - 1;
	return (e) => {
		let n = e instanceof Date ? e.getTime() : t.indexOf(e);
		return i > r ? (n - r) / (i - r) : 0;
	};
}
function ne(e, t) {
	let n = N.axis, r = Math.max(0, ...t.map((e) => e.value)), i = $(t);
	return [T(e, {
		x: "x",
		stroke: n,
		strokeDasharray: "3 3"
	}), k(U(e.map((e) => ({
		...e,
		y: r,
		end: i(e.x) > .5
	})), {
		x: "x",
		y: "y",
		text: "label",
		fill: n,
		fontSize: 11,
		anchor: (e) => e.end ? "end" : "start",
		dx: (e) => e.end ? -4 : 4
	}))];
}
function re(e, t = {}) {
	let { area: n = [], stacked: r = !1, dashed: i = [], guides: a = !0, labels: o = !1, markers: s = [], grouped: c = !1 } = t, { format: l = b, xFormat: u, valueLabel: d, colors: f, legend: v, tooltip: S = !0, margin: T, xPadding: D, yAxis: j, highlight: F, threshold: I, edges: L } = t, R = _(e), z = L && !r && L.before.length > 0 && L.after.length > 0 ? L : void 0, B = z ? [
		...z.before,
		...e,
		...z.after
	] : e, V = B.filter((e) => n.includes(e.series)), H = r || V.length > 0, U = T ?? (a ? void 0 : J), K = o && U ? {
		...U,
		top: Math.max(U.top ?? 0, X),
		bottom: Math.max(U.bottom ?? 0, Y)
	} : U, $ = r ? [P(e, {
		...m,
		layout: A({ order: R }),
		fillOpacity: .85,
		curve: x
	})] : [...V.length ? [k(P(V, {
		...m,
		curve: x,
		...I ? {
			fill: `url(#${G})`,
			fillOpacity: 1
		} : { fillOpacity: .12 }
	}))] : [], ...z ? [...Z(B, i).map((e) => k(e)), w(e, {
		...m,
		strokeOpacity: 0,
		curve: x
	})] : Z(e, i)];
	return E({
		theme: M,
		guides: a,
		margin: K,
		...I && V.length ? { gradients: [q(I, V)] } : {},
		marks: [
			...$,
			...o && !r ? [te(e, l)] : [],
			...s.length && !r ? ne(s, e) : [],
			...H ? [C([0])] : [],
			...c ? [O({
				x: !0,
				y: !1,
				stroke: N.axis,
				strokeDasharray: "3 3"
			})] : [],
			...c ? ee(e, r ? Q(e, R) : "value") : []
		],
		scales: {
			x: y(B, "point", u, z ? -.5 : D),
			y: h(l, d, j)
		},
		color: g(R, f, (v ?? !0) && a, F),
		...c ? {
			focus: "group-x",
			maxFocusDistance: Infinity
		} : {},
		...c ? { focusRing: !1 } : {},
		tooltip: S ? c ? p(e, l, u, ["right", "left"]) : W(e, l, u) : void 0
	});
}
//#endregion
export { P as n, re as t };

//# sourceMappingURL=line-0Qabwcym.js.map